/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { SubscriptionDisplayPaginatedResponse } from '../model/subscriptionDisplayPaginatedResponse';
// @ts-ignore
import { SubscriptionStateEnum } from '../model/subscriptionStateEnum';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CommerceVmcfsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get all vmcfs subscription display by org id.
     * Get all vmcfs subscription display by org id.
     * @param orgId Organization identifier
     * @param sortBy Sort the subscription display by this column
     * @param sortByOrder Sort the properties by this order
     * @param id Long ID query param
     * @param serialNumber Subscription Serial Number In Optional Filter
     * @param startDateStart Start date to begin with in YYYY-MM-DD
     * @param startDateEnd Start date to end with in YYYY-MM-DD
     * @param endDateStart End date to begin with in YYYY-MM-DD
     * @param endDateEnd End date to end with in YYYY-MM-DD
     * @param quantity Quantity In Optional Filter
     * @param subscriptionState Subscription state
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param chargeId Charge Id In Optional Filter
     * @param datacenter Datacenter In Optional Filter
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionDisplayPaginatedResponse>;
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionDisplayPaginatedResponse>>;
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionDisplayPaginatedResponse>>;
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state' | 'createdAt' | 'updatedAt' | 'chargeId' | 'datacenter' | 'serviceType' | 'subscriptionHistoryId', sortByOrder: 'ASC' | 'DESC', id?: number, serialNumber?: string, startDateStart?: string, startDateEnd?: string, endDateStart?: string, endDateEnd?: string, quantity?: number, subscriptionState?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeId?: string, datacenter?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getSubscriptionDisplayVmcfs.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getSubscriptionDisplayVmcfs.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getSubscriptionDisplayVmcfs.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumber, 'serial-number');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStart, 'start-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEnd, 'start-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStart, 'end-date-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEnd, 'end-date-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantity, 'quantity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionState, 'subscription-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'created-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'created-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updated-ts-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updated-ts-end');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeId, 'charge-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenter, 'datacenter');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vmcfs/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/commerce/subscriptions`;
        return this.httpClient.request<SubscriptionDisplayPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
